import { DataResult } from '@/utils/mockUtils'
export default {
  getCategoryList:(request) => {
    const data = [ 
        {
          "id": 3653,
          "parentId": 0,
          "name": "新品播报类",
          "path": "/3653",
          "children": [
            {
              "id": 36533,
              "parentId": 3,
              "name": "新品播报类11",
              "path": "/36533"
            },
            {
              "id": 36534,
              "parentId": 4,
              "name": "新品播报类4",
              "path": "/36534"
            },
            {
              "id": 36535,
              "parentId": 5,
              "name": "新品播报类5",
              "path": "/36535"
            }
          ]
        },
        {
          "id": 3654,
          "parentId": 0,
          "name": "产品介绍类",
          "path": "/3654",
          "children": [
            {
              "id": 36533,
              "parentId": 3,
              "name": "新品播报类11",
              "path": "/36533"
            },
            {
              "id": 36534,
              "parentId": 4,
              "name": "新品播报类4",
              "path": "/36534"
            },
            {
              "id": 36535,
              "parentId": 5,
              "name": "新品播报类5",
              "path": "/36535"
            }
          ]
        },
        {
          "id": 3655,
          "parentId": 0,
          "name": "操作指南",
          "path": "/3655",
        }
      
    ]
    return DataResult.getSuccessResponse({itemArr: data})
  },
  handleSuccess() {
    return DataResult.getSuccessResponse({content: '', message: '操作成功'})
  },
  getArticleList(request) {
    const data = [
      {
        "id": 3366, 
        "title": "初次部署",
        "description": "初次部署扫盲",
        "content": "xxxxx",
        "outerLink": true,
        "category": {
          "id": 2,
          "name": "新品速递"
        },
        url: "http://mp.weixin.com/xxxxx",
        coverUrl: "http://mp.weixin.com/xxxxx",
        hot: true,
        top: false,
        publish: true,
        createTime: 12121312312,
        updateTime: 12121312312
      },
      {
        "id": 3368, 
        "title": "初次部署",
        "description": "初次部署扫盲",
        "content": "xxxxx",
        "outerLink": true,
        "category": {
          "id": 2,
          "name": "新品速递"
        },
        url: "http://mp.weixin.com/xxxxx",
        coverUrl: "http://mp.weixin.com/xxxxx",
        hot: true,
        top: false,
        publish: true,
        createTime: 12121312312,
        updateTime: 12121312312
      },
      {
        "id": 3367, 
        "title": "初次部署",
        "description": "初次部署扫盲",
        "content": "xxxxx",
        "outerLink": true,
        "category": {
          "id": 2,
          "name": "新品速递"
        },
        url: "http://mp.weixin.com/xxxxx",
        coverUrl: "http://mp.weixin.com/xxxxx",
        hot: true,
        top: false,
        publish: true,
        createTime: 12121312312,
        updateTime: 12121312312
      }
    ]
    return DataResult.getSuccessResponse({itemArr: data, total: 3})
  },
  getArticleDetail() {
    const data = {
      id: "uuid",
      url: 'https://mp.weixin.qq.com/s/Mz1onElfRnorj1LDUHqjfQ',
      categoryId: 36534
    }
    return DataResult.getSuccessResponse({content: data})
  }
}
